export default __webpack_public_path__ + "static/media/right-arrow.289e45f2.svg";